import {VariantConfigT} from '@/lib/types/colors.types';

export const orangeConfig: VariantConfigT = {
  basic: {
    icon: 'orange',
    iconHover: 'white',
    iconActive: 'white',
    hover: 'orange',
    active: 'orange',
  },
  outline: {
    icon: 'orange',
    iconHover: 'white',
    iconActive: 'white',
    hover: 'white',
    active: 'white',
  },
  ghost: {
    icon: 'orange',
    iconHover: 'orange',
    iconActive: 'orange',
    hover: 'orange',
    active: 'orange',
  },
  gradient: {
    icon: 'white',
    iconHover: 'white',
    iconActive: 'white',
    hover: 'white',
    active: 'white',
  },
  solid: {
    icon: 'white',
    iconHover: 'white',
    iconActive: 'white',
    hover: 'white',
    active: 'white',
  },
};
